/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsLoader: {
  name: 'loader';
  data: string;
} = {
  name: 'loader',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M13 3a1 1 0 1 0-2 0v2a1 1 0 1 0 2 0V3Zm0 16a1 1 0 1 0-2 0v2a1 1 0 1 0 2 0v-2Zm5-7a1 1 0 0 1 1-1h2a1 1 0 1 1 0 2h-2a1 1 0 0 1-1-1ZM3 11a1 1 0 1 0 0 2h2a1 1 0 1 0 0-2H3Zm1.793-6.207a1 1 0 0 1 1.414 0l1.5 1.5a1 1 0 0 1-1.414 1.414l-1.5-1.5a1 1 0 0 1 0-1.414Zm1.414 14.414a1 1 0 0 1-1.414-1.414l1.5-1.5a1 1 0 0 1 1.414 1.414l-1.5 1.5Zm13-14.414a1 1 0 0 1 0 1.414l-1.5 1.5a1 1 0 1 1-1.414-1.414l1.5-1.5a1 1 0 0 1 1.414 0Zm0 13a1 1 0 0 1-1.414 1.414l-1.5-1.5a1 1 0 0 1 1.414-1.414l1.5 1.5Z" fill="currentColor"/></svg>`,
};
